module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.27e50ffd.otf";